import styled from 'styled-components';
import { RADIUS } from '~/common/layout-propertis/radius';
import { SPACING } from '~/common/layout-propertis/spacing';

export const StyContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SPACING._8};
  width: 100%;
  align-items: center;
`;

interface IStyProgressContent {
  maxSize: string;
  height: string;
}

export const StyProgressContent = styled.div<IStyProgressContent>`
  width: 100%;
  max-width: ${({ maxSize }) => maxSize};
  background-color: ${({ theme }) => theme.neutral[700]};
  border-radius: ${RADIUS._999};
  height: ${({ height }) => height};
`;

interface IStyProgress {
  percentage: number;
  progressColor: string;
}

export const StyProgress = styled.div<IStyProgress>`
  width: ${({ percentage }) => `${percentage}%`};
  height: 100%;
  background-color: ${({ progressColor }) => progressColor};
  border-radius: ${RADIUS._999};
  transition: width 0.3s ease-in-out;
`;
